//Livewire & AlpineJS
import { Livewire, Alpine } from '../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'
Alpine.plugin(Clipboard)
Livewire.start()

// Core version + navigation, pagination modules
import Swiper, { Navigation, Pagination, Grid, Autoplay, Thumbs, EffectCards, FreeMode ,Controller,EffectFade, EffectCube, EffectCreative,Mousewheel } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-cube';
import 'swiper/css/effect-flip';
import 'swiper/css/effect-cards';
import 'swiper/css/grid';
import 'swiper/css/autoplay';
import 'swiper/css/free-mode';
// Initialize Swiper modules
Swiper.use([Navigation, Pagination, Grid, Autoplay, Thumbs, EffectCards, FreeMode,Controller,EffectFade, EffectCube, EffectCreative,Mousewheel]);

// Export for global use if needed
window.Swiper = Swiper

// PURE COUNTER
import PureCounter from "@srexi/purecounterjs";
window.PureCounter = PureCounter

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// Lazy load
import lazySizes from 'lazysizes';

// FS Light Box
import FsLightbox from "fslightbox";

// Run App
const setupApp = ()=>
{
    lazySizes.init();
    refreshFsLightbox();
};

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})
